@use "~theme/breakpoints";
@use "~theme/typographyV2" as typography;

.dateContainer {
  box-sizing: border-box;
  padding: 10px 0px 10px 10px;
  background-color: var(--white);
  width: 100%;
  @include breakpoints.desktop {
    padding: 20px;
  }
}

.officeSection {
  padding: 0px;
}

.officeSectionCustom {
  padding: 20px;
  padding-bottom: 0px;
}

.borderDivider {
  border: 1px solid rgba(0, 51, 102, 0.3);
  padding: 0px 10px;
}

.borderDividerSection {
  padding: 0px;
  width: 100%;
  margin-left: 0;
}

.mobileView {
  @include breakpoints.desktop {
    display: none;
  }
}

.noAvailableDoctors {
  @include typography.body;
  color: var(--blue-02);
}

/* --- footer styles ---------------------------- */

.footer {
    padding: 30px 0;
    background: var(--white);
    border-top: 1px solid var(--gray-06);
    margin: 20px -20px 0; 
    width: calc(100% + 40px);
  
    @include breakpoints.desktop {
      flex-direction: row;
      padding-top: 44px;
      padding-left: 0;
      padding-right: 0;
    }
  }

.footerSection {
  flex: 1;
}

.footerLeft {
  @include breakpoints.desktop {
    margin-left: 20%;
  }
}

.footerRight {
  @include breakpoints.desktop {
    margin-right: 20%;
  }
}

.footerDivider {
  margin: 28px 25%;
  height: 1px;
  border: 0;
  background-color: var(--gray-06);

   @include breakpoints.desktop {
    margin: 0;
    height: auto;
  }

  @include breakpoints.desktop {
    flex-shrink: 0;
    height: auto;
    width: 1px;
    margin: 0 64px;
  }
}

.footerHeading {
  font-family: typography.$font-mont;
  font-weight: 700;
  font-style: normal;
  font-size: 15.9px;
  color: var(--brand-indigo);
  line-height: 24px;
  letter-spacing: 0px;
  text-align: center;
  vertical-align: middle;
  text-transform: uppercase;
  margin: 0;

  @include breakpoints.desktop {
    padding-bottom: 8px;
  }
}

.footerHeadingWithTooltip {
  display: flex;
  justify-content: center;
  font-family: typography.$font-mont;
  font-weight: 700;
  font-style: normal;
  font-size: 15.9px;
  color: var(--brand-indigo);
  line-height: 24px;
  letter-spacing: 0px;
  text-align: center;
  vertical-align: middle;
  text-transform: uppercase;

  > :first-child {
    margin-right: 8px;
  }

  @include breakpoints.desktop {
    align-items: center;
    gap: 8px;

    > :first-child {
      margin-right: 0;
    }
  }
}

.footerParagraph {
  text-align: center;
  margin: 8px 0 0;
  font-family: typography.$font-mont;
  font-weight: 400;
  font-style: normal;
  font-size: 16px;
  color: var(--black);

  line-height: 22.4px;
  letter-spacing: 0.32px;
  text-align: center;
  vertical-align: middle;


  @include breakpoints.desktop {
    padding: 0px;
    margin: 0px;
  }
}

.footerPhoneLink {
  white-space: nowrap;
  color: var(--Brand-Indigo, #143467);
}

.footerLinkContainer {
  text-align: center;
  margin: 32px 0;
  font-family: typography.$font-mont;
  font-weight: 600;
  font-style: normal;
  font-size: 16px;
  line-height: 22.4px;
  letter-spacing: 0.32px;
  text-align: center;
  vertical-align: middle;
  text-transform: uppercase;
  text-decoration: underline;
  text-decoration-style: solid;
  text-decoration-thickness: 0%;

  @include breakpoints.desktop {
    margin: 16px 0;
    text-decoration: none;
  }
}

.footerLink {
  color: var(--brand-indigo);
  text-transform: uppercase;

  @include breakpoints.desktop {
    text-decoration: underline;
    text-underline-offset: 2px;
  }
}

.footerNextBtn {
  width: 230px;
  height: 40px;
  border-radius: 100px;
  font-family: typography.$font-mont;
  font-weight: 600;
  font-size: 14px;
  background: var(--blue-01);
  color: var(--white);
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: none;
  margin: 0 auto;

  @include breakpoints.desktop {
    width: 12%;
    margin: 30px 40px 30px 0px;
    float: right;
  }
}


.footerNextBtnCustom {
  position: absolute;
  bottom: 70px;
  right: 130px;
  z-index: 1;
  width: 230px;
  height: 40px;
  gap: 8px;
  opacity: 1;
  border-radius: 100px;
  padding: 12px 20px;
  background-color: var(--blue-01);
  color: var(--white);
  font-family: typography.$font-mont;
  font-weight: 600;
  font-style: normal;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0;
  vertical-align: middle;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  text-transform: none;
  margin-right: 20px;

  span {
    display: inline-block;
    margin: 0;
    line-height: 1;
    font-family: typography.$font-mont;
    font-weight: 600;
    font-size: 14px;
  }
}

.footerNextBtnCustomMobile {
  height: 40px;
  width: 160px;
  border-radius: 100px;
  font-family: typography.$font-mont;
  font-weight: 600;
  font-size: 14px;
  background: var(--blue-01);
  color: var(--white);
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: none;
  margin: 0;
  flex-grow: 0;
  flex-shrink: 0;
  margin-right: 290px;

  @include breakpoints.desktop {
    width: 12%;
    margin: 30px 40px 30px 0px;
    float: right;
  }
}

.footerPortal {
  margin: 0px -20px 0;  // ← negative left/right margin cancels the parent's 20px
  width: calc(100% + 40px);
  @include breakpoints.desktop {
    margin: 0;
    width: 100%;
  }
}

.weekContainer {
  box-sizing: border-box;
  height: 60px;
  padding: 0 18px;
  position: relative;
  width: 100%;

  @include breakpoints.desktop {
    height: 80px;
  }
}

.daysViewport {
  contain: inline-size;
  min-width: 0;
  overflow-x: clip;
  width: 100%;
}

.daysRow {
  display: grid;
  gap: 8px;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  width: 100%;

  @include breakpoints.mobile-small {
    gap: 10px;
    grid-template-columns:
      repeat(5, clamp(60px, calc((100% - 40px) / 4), 72px));
  }
}

.dayContainer {
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  height: 52px;
  background: var(--white);
  border: 1px solid var(--gray-03);
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 2px;
  margin: 0;
  text-align: center;
  cursor: pointer;

  @include breakpoints.desktop {
    padding: 10px;
    width: 98px;
    height: 70px;
  }

}

.daySelected {
  border: 1px solid var(--blue-02);
}

.dayWords {
  text-transform: uppercase;
  color: var(--blue-01);
  font-style: normal;
  font-family: typography.$font-mont;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 1.92px;
  text-align: center;
  vertical-align: middle;
  text-transform: uppercase;
  white-space: nowrap;


  @include breakpoints.desktop {
    @include typography.body-large;
    text-transform: uppercase;
    color: var(--blue-01);
  }
}

.monthYear {
  color: var(--datepicker-gray);
  font-family: typography.$font-mont;
  font-weight: 400;
  font-style: normal;
  font-size: 14px;
  line-height: 19.6px;
  letter-spacing: 0.32px;
  text-align: center;
  vertical-align: middle;
  white-space: nowrap;

  @include breakpoints.desktop {
    font-weight: 400;
    font-size: 16px;
    color: var(--black);
    padding-bottom: 0;
  }
}

.arrow {
  margin: 0;
  position: absolute;
  top: 14px;
  z-index: 1;
}

.arrowLeft {
  left: 0;

  @include breakpoints.desktop {
    margin-right: 8px;
  }
}

.arrowRight {
  right: 0;

  @include breakpoints.desktop {
    margin-left: 8px;
  }
}

.hideTimeSection {
  display: none;
}

.showTimeSection {
  display: block;
  margin: 0px;
}

.showTimeSectionCustom {
  display: block;
  margin: 20px;
}

.customSteps {
  display: flex;
  padding: 16px 20px;
  background-color: var(--white);
  border-bottom: 1px solid var(--blue-01-at-30);
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  position: relative;

  img { margin-right: 8px; }

  h1 {
    text-transform: none;
    margin: 0;
    padding: 0;
    flex: 1;
    font-family: typography.$font-serif;
    font-weight: 400;
    font-style: normal;
    font-size: 24px;
    line-height: 20px;
    letter-spacing: 0px;
    vertical-align: middle;
    color: var(--brand-indigo);

  }

  div {
    @include typography.button-edit;
    color: var(--blue-01);
    font-family: typography.$font-mont;
    color: var(--blue-01);
    float:right;
    padding: 1px 10px 0px 0px;
    text-align: right;
    text-decoration: underline;
    font-weight: 500;
    font-style: normal;
    font-size: 14px;
    line-height: 22.4px;
    letter-spacing: 0.32px;
    vertical-align: middle;
    text-transform: uppercase;
  }

  .headlineLimitedAvailability {
    background-color: var(--blue-03);
    height: 34px;
    color: var(--blue-01);
    display: flex;
    justify-content: center;
    padding: 8px;
    letter-spacing: 0.12em;
    font-size: 1rem;
  }
}

.vehModal {
  width: 80%;
  max-width: 80%;
  font-size: 14px;

  input { margin-right: 5px; }

  .vehTerms {
    font-size: 10px;
    line-height: 12px;
    margin: 15px 0px;
  }

  .interrogative {
    @include typography.body-semibold;
    text-align: center;
    padding-bottom: 20px;
    margin: 0;
  }

  .qualifier {
    text-align: center;
    padding-bottom: 20px;
    margin: 0;
  }

  .button {
    flex: 1;
    margin: 0 8px;
    font-size: 16px;

    &:first-child { margin-left: 0; }
    &:last-child  { margin-right: 0; }
  }

  .buttons {
    display: flex;
    flex-direction: row;
    margin-top: 25px;
  }

  .buttonRestrict {
    width: 100%;
    margin: 5px 0px;
    font-size: 14px;
  }
}

h1.selectOption {
  color: var(--black);
  font-size: 18px;
}

.headline {
  margin-top: 0px;
  font-family: typography.$font-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 28px;
  line-height: 27px;
  letter-spacing: 0px;
  vertical-align: middle;
  color: var(--brand-indigo);
}

.headlineCustom {
  font-family: typography.$font-serif;
  font-weight: 400;
  font-style: Regular;
  font-size: 28px;
  text-transform: none;
  line-height: 27px;
  letter-spacing: 0px;
  vertical-align: middle;
  color: var(--brand-indigo);
  font-style: normal;
}

.buttonWrapper {
  .container {
    position: relative;
    display: inline-block;
    width: 100%;
  }

  .tooltipContainer {
    background-color: var(--blue-02);
    color: var(--white);
    border-radius: 4px;
    visibility: hidden;
    position: absolute;
    z-index: var(--float);
    width: 300px;
    padding: 4px 8px;
  }

  .tooltipContainer p {
    @include typography.body;
    margin-top: 0;
  }

  .tooltipContainer p:last-child { margin-bottom: 0; }

  .tooltipPositionTop {
    bottom: 100%;
    left: 0;
    margin-left: 12px;
    margin-bottom: 8px;
  }

  .tooltipPositionTop::after {
    content: " ";
    position: absolute;
    top: 100%;
    left: 72px;
    margin-left: -8px;
    border-width: 8px;
    border-style: solid;
    border-color: var(--blue-02) transparent transparent transparent;
  }

  .tooltipVisible { visibility: visible; }

  .content { padding: 12px; }

  .contentContainer {
    display: flex;
    flex-direction: row;
  }

  .buttonIcon {
    border: none;
    outline: none;
    padding: 0;
    font: inherit;
    color: inherit;
    background-color: transparent;
    cursor: pointer;
  }
}

.classRed   { color: white; padding-top: 5px; font-family: typography.$font-mont; }
.classWhite { color: white; padding-top: 5px; font-family: typography.$font-mont; }

.iconCircle { width: 24px; height: 24px; }

.restrictVEHContent { margin-bottom: 10px; }

.smsFooter {
  text-align: center;
  margin-top: -16px;
  font-size: 12px;
  line-height: 140%;
  font-family: typography.$font-mont;
  margin-left: 20px;
  margin-right: 20px;
  color: var(--brand-indigo);

  @include breakpoints.desktop {
    width: 944px;
    min-height: 448px;
    display: flex;
    flex-direction: column;
    gap: 48px;
    margin: -16px auto 0;
    padding: 0 0 20px;
  }
}

.doctorSteps {
  h1 {
    background: var(--white);
  }
}

.smsHelp {
  a {
    color: inherit;
    text-decoration: none;
  }

  u,
  i {
    text-decoration: none;
  }

  @include breakpoints.desktop {
    margin: 0;
    color: var(--brand-indigo);
    font-family: typography.$font-mont;
    font-weight: 400;
    font-size: 16px;
    line-height: 140%;
    text-align: center;

    a {
      color: inherit;
      text-decoration: none;
    }
  }
}

.agreeText {
  a {
    color: inherit;
    text-decoration: none;
  }

  u {
    text-decoration: none;
  }

  @include breakpoints.desktop {
    margin: 0;
    color: var(--brand-indigo);
    font-family: typography.$font-mont;
    font-weight: 400;
    font-size: 16px;
    line-height: 140%;
    text-align: center;

    a {
      color: inherit;
      text-decoration: none;
    }

    p {
      margin: 24px 0 0;
    }

    u {
      text-decoration: none;
    }
  }
}

/* ----------------------------
   VEH MODAL SECTION
-----------------------------*/

.newvehModal {
  padding: 0px 20px 20px 20px;
  margin: 0px;

  @include breakpoints.desktop-medium {
    height: auto;
  }

  @include breakpoints.desktop-large {
    height: auto;
  }

  .conClass { }

  .nvehheader {
    /* existing styles */
    font-family: typography.$font-mont;
    font-weight: 700;
    font-size: 20px;
    line-height: 120%;
    color: var(--black);
    margin: 0px 0px 5px 0px;
  }

  .imgPatient {
    width: 100%;
    height: 200px;                /* base height */
    object-fit: cover;
    object-position: left center; /* align left as requested */
    transition: height 0.2s ease;
  }

  .newP1 {
    font-family: typography.$font-mont;
    font-weight: 600;
    font-size: 16px;
    line-height: 140%;

    span {
      font-family: typography.$font-mont;
      font-weight: 400;
      font-size: 16px;
      line-height: 140%;
    }
  }

  .newL1 {
    font-family: typography.$font-mont;
    font-weight: 400;
    font-size: 14px;
    line-height: 130%;
  }

  .listContainer {
    display: block;
    overflow: auto;
    padding-bottom: 10px;
  }

  .listImg  { width: 5%;  float: left; }
  .listText { width: 95%; float: left; }

  .newL2 {
    font-family: typography.$font-mont;
    font-weight: 400;
    font-size: 14px;
    line-height: 130%;

    ul {
      list-style: none;
      padding: 0px;
    }
  }

  .buttonAcc {
    width: 230px;
    height: 40px;
    font-family: typography.$font-mont;
    font-weight: 600;
    font-size: 14px;
    line-height: 100%;
    letter-spacing: 0;
    text-align: center;
    text-transform: none;
    color: var(--white);
    background: var(--blue-01);
    border-radius: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 16px auto 5px;
  }

  .btnGoContainer { text-align: center; }

  .iconBack { }

  .buttonGo {
    font-family: typography.$font-mont;
    font-weight: 400;
    font-size: 16px;
    line-height: 130%;
    padding: 15px 0px;
    cursor: pointer;
  }
}

.newvehModal:has(.newL2 ul li:nth-of-type(3)) .imgPatient {
  height: 120px !important;
}

.officeIcon {
  margin-top: -20px;
  filter: brightness(0) saturate(100%) invert(16%) sepia(47%) saturate(1547%) hue-rotate(195deg) brightness(97%) contrast(95%);
}

.medicaid {
  position: relative;
  border-bottom: none;
  margin-left: -30px;
  color: var(--blue-01);
  font-size: 14px;
  font-weight: 400;
  line-height: normal;
  letter-spacing: normal;
  text-transform: none;
  outline: none;
  outline-offset: inherit;
  margin-top: 3px;
  margin-bottom: 0px;
}
.mediText {
  position: absolute;
  top: 4px;
}

.mediTextV3 {
  position: static;
  font-family: typography.$font-mont;
  font-size: 10px;
}

.medicaidV3 {
  position: relative;
  border-bottom: none;
  margin-left: 0;
  color: var(--blue-01);
  font-size: 14px;
  font-weight: 400;
  line-height: normal;
  letter-spacing: normal;
  text-transform: none;
  outline: none;
  outline-offset: inherit;
  margin-top: 3px;
  margin-bottom: 0px;
}

.boldUnderline {
    text-decoration-line: underline;
    font-weight: 700;
}

.customOfficeSteps {
  padding: 5px 20px 8px 20px;
}
